// extracted by mini-css-extract-plugin
module.exports = {"warnBanner":"WarnBanner_warnBanner__3CIEU","warnText":"WarnBanner_warnText__1jtrW","warnButton":"WarnBanner_warnButton__m7atm"};